// @ts-expect-error incompatibility with node16 resolution
import {Dialog, Transition} from '@headlessui/react';
import clsx from 'clsx';
import {Fragment, useState, useEffect} from 'react';
import type {LayoutHeader} from '../../../types';
import MenuNavGroupContent from './MenuNavGroupContent.client';
import MenuNavGroupContentNew from './MenuNavGroupContentNew.client';

type Props = {
  data: LayoutHeader;
};

export default function MenuNavGroupDialog({data}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);

  const [windowWidth, setWindowWidth] = useState(0);
  
  useEffect(() => {
    function handleResize() {
      setWindowWidth(window?.innerWidth)
    }
    window?.addEventListener("resize", handleResize)
    return () => window?.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    if (windowWidth && windowWidth >= 1024) {
      handleClose()
    }
  }, [windowWidth])

  return (
    <>
      {isOpen ? (
      <p
        className={clsx(
          'cursor-pointer block link--nav mr-5',
          isOpen && 'text-main'
        )}
        onClick={handleClose}
      >
        Menu
      </p>
      ) : (
        <button
          className={clsx(
            'block link--nav mr-5',
            isOpen && 'text-main'
          )}
          onClick={handleOpen}
        >
          Menu
        </button>
      )}
      <Transition show={isOpen}>
        <Dialog
          open={isOpen}
          className="relative z-40"
          onClose={handleClose}
          static
        >
          {/* Overlay */}
          <Transition.Child
            as={Fragment}
            // enter="ease-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            // leave="ease-in duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              aria-hidden="true"
              className={clsx(
                'fixed inset-0',
                'layerDialog'
              )}
            />
          </Transition.Child>

          {/* Panel */}
          <Transition.Child
            as={Fragment}
            // enter="ease-in-out duration-500"
            enterFrom="-translate-y-screen"
            enterTo="translate-y-0"
            // leave="ease-in-out duration-500"
            leaveFrom="translate-y-0"
            leaveTo="-translate-y-screen"
          >
            <Dialog.Panel
              className="fixed top-0 w-full overflow-y-auto bg-white p-10"
            >
              <MenuNavGroupContentNew
                data={data}
                onClose={handleClose}
              />
            </Dialog.Panel>
          </Transition.Child>
        </Dialog>
      </Transition>
    </>
  );
}
